import { isObject } from './utils';

const isSerializedNodeRepresentingFormValue = (element) => element.__type === 'vgs-key';

export function traverseSubmitData(customDataObject, formValues) {
  if (isObject(customDataObject)) {
    if (isSerializedNodeRepresentingFormValue(customDataObject)) {
      /**
       * Assign specific element from an array if index is specified
       */
      if (customDataObject.elementIndex !== undefined && Array.isArray(formValues[customDataObject.key])) {
        const { elementIndex, key } = customDataObject;
        return formValues[key][elementIndex];
      }
      return formValues[customDataObject.key];
    } else {
      return Object.entries(customDataObject).reduce((acc, [key, value]) => {
        acc[key] = traverseSubmitData(value, formValues);
        return acc;
      }, {});
    }
  } else if (Array.isArray(customDataObject)) {
    return customDataObject.map((value, index) => traverseSubmitData(value, formValues));
  } else {
    return customDataObject;
  }
}
